const module = { name: 'shared/seatMap/seatMapInteractivity', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { Fandango as Fandango_context_pageDetails_showtimeData } from 'require-core';

const { context: { featureFlags }, pageDetails: { isInternal }, showtimeData } = Fandango_context_pageDetails_showtimeData;


import { Fandango_debugLog as debugLog } from 'require-core';



import { default as modal } from 'swug-fdRequire-call:Fandango/modal';



import { Fandango_xhr as xhr } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { default as accessibility } from 'swug-fdRequire-call:shared/seatMap/accessibility';



import { default as toastNotification } from 'swug-fdRequire-call:shared/global/toastNotification';



import { default as Constants } from 'swug-fdRequire-call:shared/seatMap/constants';



import { default as RenderSeatMap } from 'swug-fdRequire-call:shared/seatMap/seatMap';



const selectedSeats = []


const messageConfigs = []


let renderElement = null


let seatsData = null


let allSeatMapData = null


let confirmBtn = null


let selectedSeatsText = null


let availableSeats = null


let selectedArea = null


let selectedAreaName = null


let cartSeatIds = []


const Amenities = {
    DBOX: 'd-box'
}


const LanguageGroupCodes = ['F', 'G', 'K', 'Q']


const SeatTypes = Constants.SeatTypes


const StatusCodes = Constants.StatusCodes


const HTTPStatusCodes = {
    BAD_REQUEST: 400,
}


const Styles = {
    AREA_BTN_SELECTED: 'smp__area-btn--selected',
    HIDE: 'hide',
    HIDDEN: 'hidden',
    MINUS_DISABLED: 'icon-minus-disabled',
    MINUS_ENABLED: 'icon-minus-enabled',
    PLUS_DISABLED: 'icon-plus-disabled',
    PLUS_ENABLED: 'icon-plus-enabled',
    RESTRICTED_SEAT: 'smp__seat--R',
    SEAT: 'smp__seat',
    SEAT_OUT_OF_AREA: 'smp__seat--out-of-area',
    SEAT_SELECTED: 'smp__seat--selected',
    SEATMAP_FAIL: 'smp--fail',
    SCROLL_LEFT: 'smp__areas-wrapper--scroll-left',
    SCROLL_RIGHT: 'smp__areas-wrapper--scroll-right',
    ZOOM_BTN_DISABLED: 'zoom-btn-disabled'
}


const Selectors = {
    AREA_BTN: '.js-area-btn',
    AREA_BUTTONS_ELEMENT: '.js-smp-area-buttons',
    AREA_BUTTONS_WRAPPER_ELEMENT: '.js-smp-area-buttons-wrapper',
    AREA_ELEMENT: '.js-smp-areas',
    AREA_ELEMENT_LEFT_ARROW_BTN: '.js-smp-area-arrow-left',
    AREA_ELEMENT_RIGHT_ARROW_BTN: '.js-smp-area-arrow-right',
    AVAILABLE_SEAT: '.smp__seat--A',
    CONFIRM_SEATS_BTN: '.js-confirm-seats-btn',
    MESSAGE_MODAL: '#message-modal',
    RENDER_ELEMENT: '.js-smp-render',
    SEAT_COUNT: '#smp-seat-count-live-region',
    SEAT_MAP: '.js-smp',
    SELECTED_SEATS: '.js-selected-seats',
    SELECTED_SEATS_CONTAINER: '.js-smp-selected-seats-container',
    ZOOM_DECREASE_BTN: '.js-zoom-decrease-btn',
    ZOOM_INCREASE_BTN: '.js-zoom-increase-btn',
}


const AreaTypes = {
    ALL: { name: 'All', id: 'all' }
}


const MessageModalConfigurations = {
    WHEELCHAIR: {
        title: 'You picked a wheelchair space',
        titleIcon: 'smp__seat--wheelchair',
        message: 'This is a space for your wheelchair, not a seat.',
        confirmText: 'Yes, Select',
        cancelText: 'Go Back',
    },
    COMPANION: {
        title: 'You picked a companion seat',
        titleIcon: 'smp__seat--companion',
        message: 'This seat is for a companion to a wheelchair user who is sitting in the adjacent wheelchair space. ' +
            'If that’s not you, you might need to give up your seat at the cinema.',
        confirmText: 'Yes, Select',
        cancelText: 'Go Back',
    },
    LINKED: {
        title: 'Linked Seats',
        message: 'All linked seats must be purchased.',
        confirmText: 'Yes, Select',
        cancelText: 'Go Back',
    },
    PRESELECTED_SEATS: {
        title: 'Seats Selection Warning',
        message: 'Some seats were not available.',
        confirmText: 'Got It',
    },
    MAX_TICKET_LIMIT: {
        title: 'Maximum Seats Selected',
        message: 'You\'ve selected selected the maximum number of seats allowed. Deselect a seat to choose a different one.',
        confirmText: 'Got It',
    }
}


const UnavailableSeatCodes = StatusCodes.UNAVAILABLE.map(status => `:not(.${Styles.SEAT}--${status})`).join('')
function hasSelectedSeats() {
    return selectedSeats.length !== 0;
}
function getAvailableSeatClasses() {
    return StatusCodes.AVAILABLE.map(status => `.${Styles.SEAT}--${status}`).join(', ');
}
function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}
function updateScrollGradients(scrollContainer, wrapper, leftArrowBtn, rightArrowBtn) {
    const scrollLeft = scrollContainer.scrollLeft;
    const scrollWidth = scrollContainer.scrollWidth;
    const clientWidth = scrollContainer.clientWidth;
    const maxScroll = scrollWidth - clientWidth;
    if (scrollLeft > 1) {
        wrapper.classList.add(Styles.SCROLL_LEFT);
        leftArrowBtn.classList.remove(Styles.HIDDEN);
    }
    else {
        wrapper.classList.remove(Styles.SCROLL_LEFT);
        leftArrowBtn.classList.add(Styles.HIDDEN);
    }
    if (scrollLeft < maxScroll - 1) {
        wrapper.classList.add(Styles.SCROLL_RIGHT);
        rightArrowBtn.classList.remove(Styles.HIDDEN);
    }
    else {
        wrapper.classList.remove(Styles.SCROLL_RIGHT);
        rightArrowBtn.classList.add(Styles.HIDDEN);
    }
}
function setupAreaButtons(seatMapData) {
    if (seatMapData.areas && seatMapData.areas.length > 1) {
        const filteredAreas = seatMapData.areas.filter(area => !seatMapData.seats.every(seat => String(seat.areaId) === String(area.id)));
        const areas = [
            { name: AreaTypes.ALL.name, id: AreaTypes.ALL.id },
            ...filteredAreas.map(area => ({
                name: area.name,
                id: area.id,
            }))
        ];
        const areaElement = document.querySelector(Selectors.AREA_ELEMENT);
        areaElement.innerHTML = swig.render('_areaTabs', { areas });
        const allAreaButton = areaElement.querySelector(`[id="${AreaTypes.ALL.id}"]`);
        allAreaButton.classList.add(Styles.AREA_BTN_SELECTED);
        allAreaButton.ariaLabel = `${AreaTypes.ALL.name} - Selected`;
        selectedArea = AreaTypes.ALL.id;
        selectedAreaName = null;
        const areaButtons = areaElement.querySelectorAll(Selectors.AREA_BTN);
        areaButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                if (event.currentTarget.getAttribute('aria-disabled') === 'true') {
                    return;
                }
                setSelectedArea(event, areaButtons);
            });
            button.addEventListener('focus', (event) => {
                if (event.currentTarget.getAttribute('aria-disabled') !== 'true') {
                    return;
                }
                const liveRegion = document.querySelector(Selectors.SEAT_COUNT);
                if (liveRegion) {
                    liveRegion.textContent = `${event.currentTarget.textContent.trim()} - No seats available`;
                }
            });
        });
        areaButtons.forEach((button) => {
            if (button.id !== AreaTypes.ALL.id) {
                const hasAvailableSeats = Array.from(availableSeats).some(seat => seat.getAttribute('data-area-id') === button.id);
                button.setAttribute('aria-disabled', String(!hasAvailableSeats));
                if (!hasAvailableSeats) {
                    button.ariaLabel = `${button.textContent} - No seats available`;
                }
            }
        });
        setupAreaKeyboardNavigation(areaButtons);
        setupAreaScrolling();
    }
    else {
        selectedArea = AreaTypes.ALL.id;
        selectedAreaName = null;
    }
}
function setupZoomButtons() {
    const zoomBtnIncrease = document.querySelector(Selectors.ZOOM_INCREASE_BTN);
    const zoomBtnDecrease = document.querySelector(Selectors.ZOOM_DECREASE_BTN);
    if (zoomBtnIncrease && zoomBtnDecrease) {
        const increaseIcon = zoomBtnIncrease.querySelector('.icon');
        const decreaseIcon = zoomBtnDecrease.querySelector('.icon');
        const seatMap = document.querySelector(Selectors.RENDER_ELEMENT);
        let currentZoomFactor = 1;
        zoomBtnIncrease.setAttribute('aria-label', 'Zoom in');
        zoomBtnDecrease.setAttribute('aria-label', 'Zoom out');
        const zoom = (clickedButton, secondaryButton, zoomFactor, shouldMoveFocus = false) => {
            clickedButton.disabled = true;
            clickedButton.classList.add(Styles.ZOOM_BTN_DISABLED);
            clickedButton.setAttribute('aria-disabled', 'true');
            secondaryButton.disabled = false;
            secondaryButton.classList.remove(Styles.ZOOM_BTN_DISABLED);
            secondaryButton.setAttribute('aria-disabled', 'false');
            currentZoomFactor = zoomFactor;
            accessibility.zoom(seatMap, currentZoomFactor);
            if (shouldMoveFocus) {
                secondaryButton.focus();
            }
        };
        zoomBtnIncrease?.addEventListener('click', () => {
            if (!zoomBtnIncrease.disabled) {
                increaseIcon.classList.remove(Styles.PLUS_ENABLED);
                increaseIcon.classList.add(Styles.PLUS_DISABLED);
                decreaseIcon.classList.remove(Styles.MINUS_DISABLED);
                decreaseIcon.classList.add(Styles.MINUS_ENABLED);
                zoom(zoomBtnIncrease, zoomBtnDecrease, 1.5, true);
            }
        });
        zoomBtnDecrease?.addEventListener('click', () => {
            if (!zoomBtnDecrease.disabled) {
                decreaseIcon.classList.remove(Styles.MINUS_ENABLED);
                decreaseIcon.classList.add(Styles.MINUS_DISABLED);
                increaseIcon.classList.remove(Styles.PLUS_DISABLED);
                increaseIcon.classList.add(Styles.PLUS_ENABLED);
                zoom(zoomBtnDecrease, zoomBtnIncrease, 1, true);
            }
        });
        window.addEventListener('resize', () => {
            if (currentZoomFactor !== 1 && seatMap) {
                accessibility.zoom(seatMap, currentZoomFactor);
            }
        });
    }
}
function setSelectedArea(event, areaButtons) {
    selectedArea = event.target.id;
    selectedAreaName = event.target.id === AreaTypes.ALL.id ? null : event.target.textContent.trim();
    const clickedIndex = Array.from(areaButtons).indexOf(event.target);
    areaButtons.forEach((button, index) => {
        button.setAttribute('tabindex', index === clickedIndex ? '0' : '-1');
    });
    areaButtons.forEach((button) => {
        if (event.target.id !== button.id) {
            button.classList.remove(Styles.AREA_BTN_SELECTED);
            button.ariaLabel = button.getAttribute('aria-disabled') === 'true'
                ? `${button.textContent} - No seats available`
                : button.textContent;
            button.ariaSelected = 'false';
        }
    });
    event.target.classList.add(Styles.AREA_BTN_SELECTED);
    event.target.ariaLabel = `${event.target.textContent} - Selected`;
    event.target.ariaSelected = 'true';
    if (event.target.id === AreaTypes.ALL.id) {
        availableSeats.forEach((seatElement, index) => {
            seatElement.classList.remove(Styles.SEAT_OUT_OF_AREA);
            if (index === 0) {
                seatElement.setAttribute('tabindex', '0');
            }
            else {
                seatElement.setAttribute('tabindex', '-1');
            }
        });
    }
    else {
        document.querySelectorAll(`[data-area-id]:not([data-area-id="${event.target.id}"])${UnavailableSeatCodes}`).forEach((seatElement) => {
            if (!seatElement.classList.contains(Styles.SEAT_SELECTED)) {
                seatElement.classList.add(Styles.SEAT_OUT_OF_AREA);
                seatElement.setAttribute('tabindex', '-1');
            }
        });
        const enabledSeats = document.querySelectorAll(`[data-area-id="${event.target.id}"]${UnavailableSeatCodes}`);
        enabledSeats.forEach((seatElement, index) => {
            if (!seatElement.classList.contains(Styles.RESTRICTED_SEAT)) {
                seatElement.classList.remove(Styles.SEAT_OUT_OF_AREA);
                if (index === 0) {
                    seatElement.setAttribute('tabindex', '0');
                }
                else {
                    seatElement.setAttribute('tabindex', '-1');
                }
            }
        });
    }
    const liveRegion = document.querySelector(Selectors.SEAT_COUNT);
    if (liveRegion) {
        liveRegion.textContent = selectedAreaName ? `Area changed to ${selectedAreaName}` : 'Showing all areas';
    }
}
function setupAreaKeyboardNavigation(buttons) {
    let currentIndex = 0;
    buttons.forEach((button, index) => {
        button.setAttribute('tabindex', index === 0 ? '0' : '-1');
        button.addEventListener('keydown', (event) => {
            let targetIndex = currentIndex;
            switch (event.key) {
                case 'ArrowLeft':
                    event.preventDefault();
                    targetIndex = currentIndex > 0 ? currentIndex - 1 : buttons.length - 1;
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    targetIndex = currentIndex < buttons.length - 1 ? currentIndex + 1 : 0;
                    break;
                case 'Home':
                    event.preventDefault();
                    targetIndex = 0;
                    break;
                case 'End':
                    event.preventDefault();
                    targetIndex = buttons.length - 1;
                    break;
                case 'Enter':
                case 'Space':
                    event.preventDefault();
                    if (button.getAttribute('aria-disabled') !== 'true') {
                        setSelectedArea({ target: button }, buttons);
                    }
                    return;
                default:
                    return;
            }
            buttons[targetIndex].focus();
            currentIndex = targetIndex;
        });
        button.addEventListener('focus', () => {
            currentIndex = index;
        });
    });
}
function setupAreaScrolling() {
    const areaButtonsElement = document.querySelector(Selectors.AREA_BUTTONS_ELEMENT);
    const areaWrapperElement = document.querySelector(Selectors.AREA_BUTTONS_WRAPPER_ELEMENT);
    const leftArrowBtn = document.querySelector(Selectors.AREA_ELEMENT_LEFT_ARROW_BTN);
    const rightArrowBtn = document.querySelector(Selectors.AREA_ELEMENT_RIGHT_ARROW_BTN);
    const update = () => updateScrollGradients(areaButtonsElement, areaWrapperElement, leftArrowBtn, rightArrowBtn);
    update();
    areaButtonsElement.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    const scrollToNextBatch = (direction) => {
        const containerRect = areaButtonsElement.getBoundingClientRect();
        let targetScrollLeft;
        if (direction === 'right') {
            targetScrollLeft = areaButtonsElement.scrollLeft + containerRect.width;
        }
        else {
            targetScrollLeft = areaButtonsElement.scrollLeft - containerRect.width;
        }
        areaButtonsElement.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
        });
    };
    leftArrowBtn.addEventListener('click', () => {
        scrollToNextBatch('left');
    });
    rightArrowBtn.addEventListener('click', () => {
        scrollToNextBatch('right');
    });
}
function checkOrphanSeats(onValidationComplete) {
    if (!hasSelectedSeats() || featureFlags.ignoreOrphanSeatRules) {
        onValidationComplete(true);
        return;
    }
    const seatsToValidate = selectedSeats.filter(seatId => !cartSeatIds.includes(seatId));
    if (!seatsToValidate.length) {
        onValidationComplete(true);
        return;
    }
    const validationData = {
        showtimeId: showtimeData.id,
        selectedSeats: seatsToValidate,
    };
    xhr.ajax({
        data: validationData,
        method: 'POST',
        url: links.napiValidateSeatSelection()
    })
        .done((result) => {
        onValidationComplete(result.validationStatus === 'Valid');
    })
        .fail((err) => {
        if (err.status === HTTPStatusCodes.BAD_REQUEST) {
            const response = err.responseJSON || err.responseText;
            const errorMessaging = response[0]?.messages || response[0]?.message;
            if (Array.isArray(errorMessaging) && errorMessaging.length > 1) {
                showMessageModal({
                    title: errorMessaging[0],
                    message: errorMessaging[1],
                    confirmText: 'Got It'
                });
            }
            else {
                showMessageModal({
                    message: errorMessaging || 'We\'re currently unable to reserve your seat selection. Please try again.',
                    confirmText: 'Got It'
                });
            }
        }
        else {
            showMessageModal({
                message: 'We\'re currently unable to reserve your seat selection. Please try again.',
                confirmText: 'Got It'
            });
        }
        onValidationComplete(false);
    });
}
function validateSelectedSeats(usesTicketSelection) {
    if (hasSelectedSeats()) {
        if (usesTicketSelection) {
            navigateToTicketSelection();
        }
        else {
            postParentMessage();
        }
    }
    else {
        toastNotification.initError({
            title: 'Seat Selection Required',
            message: 'Please choose a seat to proceed.',
            dismissSelectors: [Selectors.AVAILABLE_SEAT],
        });
    }
}
function navigateToTicketSelection() {
    checkOrphanSeats((isValid) => {
        if (isValid) {
            proceedWithNavigation();
        }
    });
}
function proceedWithNavigation() {
    const seatSelectionData = {
        selectedSeats,
    };
    try {
        sessionStorage.setItem(`seatSelection-${showtimeData.showtimeHashCode}`, JSON.stringify(seatSelectionData));
    }
    catch (e) {
        debugLog.warn(module.name, 'Failed to store seat selection data', e);
    }
    const urlSegment = isInternal ? 'showtime' : 'partner';
    const queryString = window.location.search;
    window.location.href = `/tickets/${urlSegment}/${showtimeData.showtimeHashCode}/ticket-selection${queryString}`;
}
function postParentMessage() {
    checkOrphanSeats((isValid) => {
        if (!isValid) {
            return;
        }
        window.parent.postMessage({ seatIds: selectedSeats }, '*');
    });
}
function updateSelectedSeats() {
    if (selectedSeats.length === 0) {
        selectedSeatsText.innerHTML = `<strong>0 Selected</strong>`;
    }
    else {
        selectedSeatsText.innerHTML = `<strong>${selectedSeats.length} Selected:</strong> ${escapeHtml(selectedSeats.join(', '))}`;
    }
    const liveRegion = document.querySelector(Selectors.SEAT_COUNT);
    if (liveRegion) {
        const areaText = selectedAreaName ? ` in ${selectedAreaName} section` : '';
        liveRegion.textContent = selectedSeats.length === 0
            ? '0 seats selected'
            : `${selectedSeats.length} seat${selectedSeats.length !== 1 ? 's' : ''} selected${areaText}`;
    }
}
function onSeatClick(event, cb = null) {
    const seat = event.currentTarget;
    const seatId = seat.dataset.id;
    const seatType = seat.dataset.linkedSeatIds ? SeatTypes.LINKED : seat.dataset.type;
    const wasSelected = selectedSeats.indexOf(seatId) !== -1;
    if (!wasSelected) {
        const renderElement = document.querySelector(Selectors.RENDER_ELEMENT);
        const maxTicketLimitValue = renderElement?.dataset.maxTicketLimit;
        if (maxTicketLimitValue) {
            const maxTicketLimit = parseInt(maxTicketLimitValue, 10);
            const linkedSeatIds = seat.dataset.linkedSeatIds ? seat.dataset.linkedSeatIds.split(',') : [];
            const totalSeatsToAdd = 1 + linkedSeatIds.length;
            const currentSelectedCount = selectedSeats.length;
            if (currentSelectedCount + totalSeatsToAdd > maxTicketLimit) {
                showMessageModal(MessageModalConfigurations.MAX_TICKET_LIMIT);
                if (cb) {
                    return cb();
                }
                return;
            }
        }
        switch (seatType) {
            case SeatTypes.WHEELCHAIR: {
                const messageConfig = MessageModalConfigurations.WHEELCHAIR;
                const seatData = seatsData.find(seat => seat.id === seatId);
                messageConfig.title = seatData.attributes?.messageHeader ?? messageConfig.title;
                messageConfig.message = seatData.attributes?.messageBody ?? messageConfig.message;
                confirmSeatSelection(messageConfig, seat, seatId, seatType, wasSelected, cb);
                break;
            }
            case SeatTypes.COMPANION: {
                const messageConfig = MessageModalConfigurations.COMPANION;
                const seatData = seatsData.find(seat => seat.id === seatId);
                messageConfig.title = seatData?.attributes?.messageHeader ?? messageConfig.title;
                messageConfig.message = seatData?.attributes?.messageBody ?? messageConfig.message;
                confirmSeatSelection(messageConfig, seat, seatId, seatType, wasSelected, cb);
                break;
            }
            case SeatTypes.LINKED: {
                const messageConfig = MessageModalConfigurations.LINKED;
                const seatBlockId = seatsData.find(seat => seat.id === seatId).seatBlockId;
                const linkedSeatInfoBox = allSeatMapData.infoBoxes?.find(infoBox => infoBox.id === `sb-${seatBlockId}`);
                if (linkedSeatInfoBox?.imageUrl) {
                    messageConfig.blockSeatingImage = linkedSeatInfoBox.imageUrl;
                    messageConfig.blockSeatingTitle = linkedSeatInfoBox.title || 'Linked Seats';
                }
                confirmSeatSelection(messageConfig, seat, seatId, seatType, wasSelected, cb);
                break;
            }
            default:
                toggleSeat(seat, seatId, seatType, wasSelected);
                if (cb) {
                    return cb();
                }
        }
    }
    else {
        toggleSeat(seat, seatId, seatType, wasSelected);
        if (cb) {
            return cb();
        }
    }
}
function confirmSeatSelection(configuration, seat, seatId, seatType, wasSelected, cb = null) {
    toggleSeat(seat, seatId, seatType, wasSelected);
    showMessageModal(configuration, (wasConfirmed) => {
        if (!wasConfirmed) {
            toggleSeat(seat, seatId, seatType, true);
        }
        if (cb) {
            return cb();
        }
    });
}
function toggleSeat(seat, seatId, seatType, wasSelected) {
    if (wasSelected) {
        const index = selectedSeats.indexOf(seatId);
        selectedSeats.splice(index, 1);
        seat.classList.remove(Styles.SEAT_SELECTED);
        const linkedSeatElements = [];
        if (seat.dataset.linkedSeatIds) {
            seat.dataset.linkedSeatIds.split(',').forEach((blockSeatId) => {
                const blockSeat = document.querySelector(`[data-id="${blockSeatId}"]`);
                if (blockSeat) {
                    linkedSeatElements.push(blockSeat);
                    const linkedIndex = selectedSeats.indexOf(blockSeatId);
                    if (linkedIndex !== -1) {
                        selectedSeats.splice(linkedIndex, 1);
                    }
                    blockSeat.classList.remove(Styles.SEAT_SELECTED);
                }
            });
        }
        if (selectedArea !== AreaTypes.ALL.id && seat.getAttribute('data-area-id') !== selectedArea) {
            seat.classList.add(Styles.SEAT_OUT_OF_AREA);
            seat.setAttribute('tabindex', '-1');
            if (linkedSeatElements.length > 0) {
                linkedSeatElements.forEach((blockSeat) => {
                    blockSeat.classList.add(Styles.SEAT_OUT_OF_AREA);
                    blockSeat.setAttribute('tabindex', '-1');
                });
            }
        }
    }
    else {
        selectedSeats.push(seatId);
        seat.classList.add(Styles.SEAT_SELECTED);
        if (seat.dataset.linkedSeatIds) {
            seat.dataset.linkedSeatIds.split(',').forEach((blockSeatId) => {
                const blockSeat = document.querySelector(`[data-id="${blockSeatId}"]`);
                if (blockSeat) {
                    selectedSeats.push(blockSeatId);
                    blockSeat.classList.add(Styles.SEAT_SELECTED);
                }
            });
        }
    }
    RenderSeatMap.setAriaAttributes(seat, {
        'aria-checked': !wasSelected,
        'aria-label': RenderSeatMap.getAriaLabel(seatId, seatType, !wasSelected),
    });
    updateSelectedSeats();
}
function preselectSeats(preselectedSeats, renderElement) {
    const seatIds = Array.isArray(preselectedSeats)
        ? preselectedSeats.map(seatId => seatId.toUpperCase().trim())
        : preselectedSeats.split(',').map(seatId => seatId.toUpperCase().trim());
    const alreadySelected = seatIds.filter(seatId => selectedSeats.includes(seatId));
    const availableSeatIds = seatIds.filter(seatId => !selectedSeats.includes(seatId) &&
        Array.from(availableSeats).some(node => node.attributes['data-id']?.value === seatId));
    let currentIndex = 0;
    const totalAccountedFor = availableSeatIds.length + alreadySelected.length;
    function processNextSeat() {
        if (currentIndex >= availableSeatIds.length) {
            if (totalAccountedFor !== seatIds.length) {
                queueMessageModal(MessageModalConfigurations.PRESELECTED_SEATS);
            }
            return;
        }
        const seatId = availableSeatIds[currentIndex];
        const seatElement = renderElement.querySelector(`[data-id="${seatId}"]`);
        currentIndex++;
        if (seatElement) {
            onSeatClick({ currentTarget: seatElement }, processNextSeat);
        }
        else {
            processNextSeat();
        }
    }
    processNextSeat();
}
function showMessageModal(configuration, cb = null) {
    let wasConfirmed = false;
    const onConfirm = () => {
        wasConfirmed = true;
    };
    const onClose = () => {
        if (cb) {
            return cb(wasConfirmed);
        }
    };
    modal.showModal(Selectors.MESSAGE_MODAL, '_messageModal', configuration, onConfirm, onClose);
    if (configuration.title) {
        document.querySelector(Selectors.MESSAGE_MODAL)?.setAttribute('aria-label', configuration.title);
    }
}
function queueMessageModal(config) {
    messageConfigs.push(config);
}
function showMessageModalQueue() {
    if (!messageConfigs.length) {
        return;
    }
    const config = messageConfigs.shift();
    showMessageModal(config, () => {
        showMessageModalQueue();
    });
}
function setupInteractivity(renderElement, usesTicketSelection) {
    const onSelection = seat => onSeatClick({ currentTarget: seat });
    availableSeats = renderElement.querySelectorAll(getAvailableSeatClasses());
    availableSeats.forEach(seat => seat.addEventListener('click', onSeatClick));
    accessibility.navigation(renderElement, availableSeats, onSelection);
    selectedSeatsText = document.querySelector(Selectors.SELECTED_SEATS);
    confirmBtn = document.querySelector(Selectors.CONFIRM_SEATS_BTN);
    confirmBtn.addEventListener('click', () => validateSelectedSeats(usesTicketSelection));
}
function setInitialSeatSelection(renderElement, preselectedSeats) {
    let selectedSeats;
    try {
        const seatSelectionData = sessionStorage.getItem(`seatSelection-${showtimeData.showtimeHashCode}`);
        if (seatSelectionData) {
            selectedSeats = JSON.parse(seatSelectionData)?.selectedSeats;
        }
    }
    catch (error) {
        console.error('Error reading seat selection from session storage:', error);
    }
    if (selectedSeats) {
        preselectSeats(selectedSeats, renderElement);
    }
    else if (preselectedSeats) {
        preselectSeats(preselectedSeats, renderElement);
    }
}
function setAmenityMessaging() {
    const seatMapContainer = document.querySelector(Selectors.SEAT_MAP);
    const hasFailed = seatMapContainer?.classList.contains(Styles.SEATMAP_FAIL);
    if (hasFailed) {
        return;
    }
    if (showtimeData && showtimeData.amenities?.length > 0) {
        const dboxAmenity = showtimeData.amenities.find(amenity => amenity.name.toLowerCase() === Amenities.DBOX);
        if (dboxAmenity) {
            queueMessageModal({
                markup: `
            <span class="message-modal__title-icon message-modal__title-icon--dbox icon-amenity--dbox"></span>
            <p class="message-modal__message message-modal__message--dbox">${escapeHtml(dboxAmenity.longDescription)}</p>
          `,
                confirmText: 'Got It',
                hideCloseButton: true,
            });
        }
        const languageGroups = showtimeData.amenities.filter(amenity => LanguageGroupCodes.includes(amenity.groupCode));
        let languageMessage;
        if (languageGroups.length > 1) {
            languageMessage = showtimeData.popupMessage;
        }
        else if (languageGroups.length > 0) {
            languageMessage = languageGroups[0].shortDescription;
        }
        if (languageMessage) {
            const config = {
                markup: `
            <div class="smp__message-modal--body">
                <span class="smp__message-modal--language-icon"></span>
                <span class="smp__message-modal--text">${languageMessage}</span>
            </div>
          `,
                confirmText: 'Got It',
                hideCloseButton: true,
            };
            queueMessageModal(config);
        }
    }
}
function init({ cartSeats, container, seatMapData, preselectedSeats, usesTicketSelection }) {
    renderElement = container.querySelector(Selectors.RENDER_ELEMENT);
    seatsData = seatMapData.seats;
    allSeatMapData = seatMapData;
    cartSeatIds = (cartSeats || []).map(id => id.toUpperCase());
    setupInteractivity(renderElement, usesTicketSelection);
    if (cartSeatIds.length) {
        preselectSeats(cartSeatIds, renderElement);
    }
    else {
        setInitialSeatSelection(renderElement, preselectedSeats);
    }
    setAmenityMessaging();
    showMessageModalQueue();
    setupAreaButtons(seatMapData);
    setupZoomButtons();
    $(Selectors.SELECTED_SEATS_CONTAINER).removeClass(Styles.HIDE);
}
module.exports = {
    init,
};
export default module.exports;